<template lang='pug'>
div.nopadding
    div.fullwidth(v-if="$route.params.lang == 'en'")
        div.padding
            ColumnContainer
                .column.company-text(slot='left')
                    h1.title.secondary-header About Us

                    p At BSS Hochspannungstechnik, we specialize in partial discharge (PD) monitoring solutions for electrical assets used in power transmission and distribution. Our monitoring systems and sensors help utilities, grid operators, and industrial companies worldwide assess asset condition, detect developing insulation defects, and prevent failures at an early stage.
                    p Our approach combines advanced measurement technology with simple integration and intuitive operation, enabling effective condition monitoring without unnecessary complexity.
                .column.company-image-column.center-content(slot='right')
                    img.company-image.logo(src='../assets/svg/bsslogo_mini.svg', width='100%', alt='High-voltage installation', title='High-voltage installation')

        Section(color='color3')
            ColumnContainer(reverse)
                .column.company-text(slot='left')
                    h2 Quality "Made in Germany"
                    p Our products are developed and manufactured in Stuttgart, Germany, ensuring short development cycles, direct quality control, and high manufacturing standards.
                    p Every monitoring system, sensor, and signal generator undergoes comprehensive end‑of‑line testing before delivery. Final assembly and verification are performed individually for each unit to ensure reliable operation in the field.
                    p This commitment to quality enables our customers worldwide to rely on our technology for long‑term asset monitoring and condition assessment.
                .column.company-image-column.center-content(slot='right')
                    Carousel.company-carousel(:perPage="1", autoplay=true, :autoplayTimeout="3500", loop=true, navigationEnabled=true, :paginationEnabled="false")
                        Slide.img-center
                            source(type='image/webp', :srcset="require('@/assets/photos/aboutus/Fraese.webp')")
                            img.company-image(:src="require('@/assets/photos/aboutus/Fraese.jpg')", width='100%', alt='Manufacturing on a CNC milling machine', title='Manufacturing on a CNC milling machine')
                        Slide.img-center
                            source(type='image/webp', :srcset="require('@/assets/photos/aboutus/Produktion DVS-50.webp')")
                            img.company-image(:src="require('@/assets/photos/aboutus/Produktion DVS-50.jpg')", width='100%', alt='Production of the UHF-DVS-50', title='Production of the UHF-DVS-50')
                        Slide.img-center
                            source(type='image/webp', :srcset="require('@/assets/photos/aboutus/Produktion PS1.webp')")
                            img.company-image(:src="require('@/assets/photos/aboutus/Produktion PS1.jpg')", width='100%', alt='Production of the UHF-PS1', title='Production of the UHF-PS1')

        div.padding
            ColumnContainer
                .column.company-text(slot='left')
                    h2 From Research to Practice
                    p Founded in 2013 as a spin‑off from the Institute of Power Transmission and High Voltage Technology (IEH) at the University of Stuttgart, BSS combines scientific expertise with practical engineering. The company was founded by Dr. Martin Siegel, now Managing Director of BSS, and Dr. Michael Beltle, who leads the EMC department and high‑voltage laboratory at the University of Stuttgart.
                    p Our research roots continue to shape the company today. Close collaboration with academia, utilities, manufacturers, and industry partners ensures that our solutions remain technically advanced and focused on real‑world applications.
 

                .column.company-image-column.center-content(slot='right')
                    picture
                        source(type='image/webp', srcset='@/assets/photos/aboutus/Forschung.webp')
                        img.company-image(src='@/assets/photos/aboutus/Forschung.jpg', width='100%', alt='Dr. Michael Beltle (l) and Dr. Martin Siegel (r) with installed PDM-600', title='Dr. Michael Beltle (l) and Dr. Martin Siegel (r) with installed PDM-600')

        Section(color='color2')
            ColumnContainer(reverse)
                .column.company-text(slot='left')
                    h2 The People Behind the Technology
                    p Behind our solutions is a highly specialized team of engineers and developers with deep expertise in high‑voltage engineering, measurement technology, and software development.
                    p The short decision‑making paths and direct communication that characterize our company are reflected in the way we work with our customers. We respond quickly, adapt flexibly to project requirements, and focus on delivering practical, effective solutions. By combining technical expertise with close customer collaboration, we ensure that our products and services meet real‑world challenges in the field.
                .column.company-image-column.center-content(slot='right')
                    picture
                        source(type='image/webp', srcset='@/assets/photos/aboutus/IMG_5915.webp')
                        img.company-image(src='@/assets/photos/aboutus/IMG_5915.jpg', width='100%', alt='Collaborative development work at BSS', title='Collaborative development work at BSS')
    div.fullwidth(v-if="$route.params.lang == 'de'")
        div.padding
            ColumnContainer
                .column.company-text(slot='left')
                    h1.title.secondary-header Über uns

                    p Wir, die BSS Hochspannungstechnik GmbH, sind spezialisiert auf Teilentladungs (TE)-Monitoring für Betriebsmittel der elektrischen Energieversorgung. 

                    p Mit unseren Monitoringsystemen und Sensoren unterstützen wir Energieversorger, Netzbetreiber, Stadtwerke und Industrieunternehmen weltweit dabei, den Zustand ihrer Anlagen sicher zu überwachen und Ausfälle frühzeitig zu verhindern. 

                    p Unser Ansatz dabei: Wir verbinden hochmoderne Messtechnik mit einfacher Integration und intuitiver Bedienung.
                .column.company-image-column.center-content(slot='right')
                    img.company-image.logo(src='../assets/svg/bsslogo_mini.svg', width='100%', alt='Hochspannungsanlage', title='Hochspannungsanlage')

        Section(color='color3')
            ColumnContainer(reverse)
                .column.company-text(slot='left')
                    h2 Qualität „Made in der Region Stuttgart“
                    p Unsere Produkte werden in der Region Stuttgart nicht nur entwickelt, sondern auch gefertigt. Deutscher Qualitätsanspruch ist für uns kein Buzzword, sondern gelebter Alltag.

                    p Die Endmontage erfolgt bei uns in Handarbeit: Jedes Monitoringsystem, jeder Sensor und jeder Signalgenerator wird vor der Auslieferung einzeln und streng geprüft.

                    p Nur so können wir garantieren, dass sich unsere Kunden weltweit auf unsere Technik verlassen können.
                .column.company-image-column.center-content(slot='right')
                    Carousel.company-carousel(:perPage="1", autoplay=true, :autoplayTimeout="3500", loop=true, navigationEnabled=true, :paginationEnabled="false")
                        Slide.img-center
                            source(type='image/webp', :srcset="require('@/assets/photos/aboutus/Fraese.webp')")
                            img.company-image(:src="require('@/assets/photos/aboutus/Fraese.jpg')", width='100%', alt='Fertigung an einer CNC-Fräsmaschine', title='Fertigung an einer CNC-Fräsmaschine')
                        Slide.img-center
                            source(type='image/webp', :srcset="require('@/assets/photos/aboutus/Produktion DVS-50.webp')")
                            img.company-image(:src="require('@/assets/photos/aboutus/Produktion DVS-50.jpg')", width='100%', alt='Produktion des DVS-50', title='Produktion des UHF-DVS-50')
                        Slide.img-center
                            source(type='image/webp', :srcset="require('@/assets/photos/aboutus/Produktion PS1.webp')")
                            img.company-image(:src="require('@/assets/photos/aboutus/Produktion PS1.jpg')", width='100%', alt='Produktion des PS1', title='Produktion des UHF-PS1')

        div.padding
            ColumnContainer
                .column.company-text(slot='left')
                    h2 Aus der Forschung in die Praxis
                    p Gegründet wurde BSS im Jahr 2013 als Spin-off aus dem Institut für Energieübertragung und Hochspannungstechnik (IEH) der Universität Stuttgart. Die Gründer: Dr. Martin Siegel, der BSS heute als Geschäftsführer leitet, und Dr. Michael Beltle, der inzwischen die EMV-Abteilung und das Hochspannungslabor der Universität Stuttgart verantwortet.

                    p Dieser Ursprung in der Forschung prägt unsere Identität bis heute. Die enge Verbindung zur Universität und der kontinuierliche Austausch mit Wissenschaft und Industrie bilden das starke Fundament für unsere praxisnahen, zukunftsfähigen Lösungen.

                .column.company-image-column.center-content(slot='right')
                    picture
                        source(type='image/webp', srcset='@/assets/photos/aboutus/Forschung.webp')
                        img.company-image(src='@/assets/photos/aboutus/Forschung.jpg', width='100%', alt='Dr. Michael Beltle (l) und Dr. Martin Siegel (r) mit installiertem PDM-600', title='Dr. Michael Beltle (l) und Dr. Martin Siegel (r) mit installiertem PDM-600')

        Section(color='color2')
            ColumnContainer(reverse)
                .column.company-text(slot='left')
                    h2 Unser Team: Technisch auf höchstem Niveau. Menschlich auf Augenhöhe.
                    p Hinter unseren Lösungen steht ein hochspezialisiertes Team aus Ingenieuren und Entwicklern mit einer gemeinsamen Leidenschaft für Hochspannungstechnik. 

                    p Die kurzen Entscheidungswege und der direkte, unkomplizierte Austausch, der unsere Firmenkultur intern prägt, spüren auch unsere Kunden: 

                    p Wir reagieren schnell, flexibel und stets lösungsorientiert auf ihre Anforderungen.
                .column.company-image-column.center-content(slot='right')
                    picture
                        source(type='image/webp', srcset='@/assets/photos/aboutus/IMG_5915.webp')
                        img.company-image(src='@/assets/photos/aboutus/IMG_5915.jpg', width='100%', alt='Gemeinsame Entwicklungsarbeit bei BSS', title='Gemeinsame Entwicklungsarbeit bei BSS')



</template>

<script>
import Section from "@/components/Section.vue";
import ColumnContainer from "@/components/ColumnContainer.vue";
import { Carousel, Slide } from 'vue-carousel'

export default {
    components: { Carousel, Slide, Section, ColumnContainer },
    meta: {
        de: {
            title: "BSS - Über uns",
            description:
                "Die BSS Hochspannungstechnik GmbH ist ein Start-Up im Bereich der Energietechnik, das von Doktoranden des Instituts für Energieübertragung und Hochspannungstechnik (IEH) der Universität Stuttgart im Jahr 2013 gegründet wurde.",
        },
        en: {
            title: "BSS - About Us",
            description:
                "BSS Hochspannungstechnik GmbH is a start-up in the field of energy technology, founded in 2013 by doctoral researchers from the Institute of Power Transmission and High Voltage Technology (IEH) at the University of Stuttgart.",
        },
    },
};
</script>

<style lang='sass' scoped>
.padding
    padding: 35px 6.5%

.company-text
    flex: 0 0 60%
    width: 60%

.company-image-column
    flex: 0 0 30%
    width: 30%

.company-carousel
    width: 100%

.company-image
    display: block
    width: 100%
    max-height: 270px
    object-fit: contain

.company-image.logo
    width: 80%
    
@media(max-width: $mobile-breakpoint)
    .company-image.logo
        display: none

@media(max-width: $mobile-breakpoint)
    .company-text, .company-image-column
        flex: 0 0 100%
        width: 100%

</style>